import authority from '_common/services/api/authority';
import { paths } from '_types/authority';

type OnboardingStatusArgs =
  paths['/api/authority/user/profile/edit/onboarding']['post']['requestBody']['content']['multipart/form-data'] & {
    invalidateUserTag?: boolean;
  };

export const onboardingApi = authority.injectEndpoints({
  endpoints: (builder) => ({
    onboardingStatus: builder.mutation<
      paths['/api/authority/user/profile/edit/onboarding']['post']['responses']['200'],
      OnboardingStatusArgs
    >({
      query: ({ target, step, skip, journey }) => {
        return {
          url: '/user/profile/edit/onboarding',
          method: 'POST',
          body: { target, step, skip, journey },
        };
      },
      invalidatesTags: (_result, _error, arg) =>
        arg.invalidateUserTag === false
          ? []
          : [
              {
                type: 'User',
                id: 'Current',
              },
            ],
    }),
  }),
});

// Export queries and mutations
export const { useOnboardingStatusMutation } = onboardingApi;

export default onboardingApi;
